import React, { useState } from "react";
import { Link } from "react-router";
import "./Navbar.css";
import { imageServerUrl, imageSizes } from "../../constants/config";
export interface NavbarProps {
  logoUrl: string;
  loading?: boolean;
}
const Navbar: React.FC<NavbarProps> = ({ logoUrl, loading }) => {
  // console.log("Navbar logoUrl:", logoUrl);
  const [isOpen, setIsOpen] = useState(false);
  if (loading) {
    return (
      <nav className="navbar loading-navbar">
        <div className="loading"></div>
      </nav>
    );
  }
  return (
    <nav className="navbar">
      <Link to="/">
        <img
          src={`${imageServerUrl}/image/${imageSizes.thumbnail}/${logoUrl}`}
          alt="Logo"
          className="navbar-logo"
        />
      </Link>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`burger-menu ${isOpen ? "open" : ""}`}
      >
        <div className="line1"></div>
        <div className="line2"></div>
        <div className="line3"></div>
      </div>
      <ul className={`navbar-list ${isOpen ? "open" : ""}`}>
        <li className="navbar-list-item">
          <Link to="/" onClick={() => setIsOpen(false)}>Etusivu</Link>
        </li>
        <li className="navbar-list-item">
          <Link to="/cars" onClick={() => setIsOpen(false)}>Vaihtoautot</Link>
        </li>
        {/* <li className="navbar-list-item">
                    <Link to="/contact">Contact</Link>
                </li> */}
      </ul>
    </nav>
  );
};

export default Navbar;
